function r(r,p){return{...r,rpcUrls:{...r.rpcUrls,privy:{http:[p]}}}}export{r as addPrivyRpcToChain};
